export enum LogsKeyEnum {
  YES_ANSWER = 'YES_ANSWER',
  NO_ANSWER = 'NO_ANSWER',
  NA_ANSWER = 'NA_ANSWER',
  PARTIAL_ANSWER = 'PARTIAL_ANSWER',
  REMOVE_ANSWER = 'REMOVE_ANSWER',
  SAVE_COMMENT = 'SAVE_COMMENT',
  EDIT_COMMENT = 'EDIT_COMMENT',
  DELETE_COMMENT = 'DELETE_COMMENT',
  SAVE_AUDITOR_COMMENT = 'SAVE_AUDITOR_COMMENT',
  EDIT_AUDITOR_COMMENT = 'EDIT_AUDITOR_COMMENT',
  DELETE_AUDITOR_COMMENT = 'DELETE_AUDITOR_COMMENT',
  MANAGER_APPROVAL = 'MANAGER_APPROVAL',
  MANAGER_DENIAL = 'MANAGER_DENIAL',
  MANAGER_EXCLUDE = 'MANAGER_EXCLUDE',
  ARTIFACT_DOWNLOAD = 'ARTIFACT_DOWNLOAD',
  ARTIFACT_DELETE = 'ARTIFACT_DELETE',
  ARTIFACT_UPLOAD = 'ARTIFACT_UPLOAD',
  STRONG_AUDIT = 'STRONG_AUDIT',
  SATISFACTORY_AUDIT = 'SATISFACTORY_AUDIT',
  NEED_IMPROVEMENT_AUDIT = 'NEED_IMPROVEMENT_AUDIT',
  CONFIRM_REASSEMENT = 'CONFIRM_REASSEMENT',
  WEAK_AUDIT = 'WEAK_AUDIT',
  UPDATE_AUDIT_STATUS = 'UPDATE_AUDIT_STATUS',
  QUESTION_TYPE = 'QUESTION_TYPE',
  ARTIFACT_SETTINGS = 'ARTIFACT_SETTINGS',
  MANAGER_APPROVAL_SETTINGS = 'MANAGER_APPROVAL_SETTINGS',
  UPDATE_VERSION_FREQUENCY = 'UPDATE_VERSION_FREQUENCY',
  ADD_TAG = 'ADD_TAG',
  REMOVED_TAG = 'REMOVED_TAG',
  UPDATE_INTEGRATION_SETTING = 'UPDATE_INTEGRATION_SETTING',
  UPDATE_SMART_MAPPING_SETTING = 'UPDATE_SMART_MAPPING_SETTING',
  SELF_ASSIGNMENT = 'SELF_ASSIGNMENT',
  ADDED_ASSIGNMENT = 'ADDED_ASSIGNMENT',
  ADDED_REVIEWER = 'ADDED_REVIEWER',
  REMOVED_ASSIGNMENT = 'REMOVED_ASSIGNMENT',
  REMOVED_REVIEWER = 'REMOVED_REVIEWER',
  PERMANENTLY_REMOVED_ASSIGNMENT = 'PERMANENTLY_REMOVED_ASSIGNMENT',
  SELF_REMOVED_ASSIGNMENT = 'SELF_REMOVED_ASSIGNMENT',
  SELF_PERMANENTLY_REMOVED_ASSIGNMENT = 'SELF_PERMANENTLY_REMOVED_ASSIGNMENT',
  CONFIRM_ASSESSMENT = 'CONFIRM_ASSESSMENT',
  UNCONFIRM_ASSESSMENT = 'UNCONFIRM_ASSESSMENT',
  REMOVE_STATUS = 'REMOVE_STATUS',
  UPDATE_INFO_SEC = 'UPDATE_INFO_SEC',
  COMMENTS_SETTINGS = 'COMMENTS_SETTINGS',
  REMEDIATE_TASK = 'REMEDIATE_TASK',
  REMEDIATE_TASK_OWNER = 'REMEDIATE_TASK_OWNER',
  IGNORE_TASK_OWNER = 'IGNORE_TASK_OWNER',
  SAVE_RISK_COMMENT = 'SAVE_RISK_COMMENT',
  EDIT_RISK_COMMENT = 'EDIT_RISK_COMMENT',
  DELETE_RISK_COMMENT = 'DELETE_RISK_COMMENT',
  ESCALATE_RISK = 'ESCALATE_RISK',
  DE_ESCALATE_RISK = 'DE_ESCALATE_RISK',
  ARCHIVE_RISK = 'ARCHIVE_RISK',
  REACTIVATE_RISK = 'REACTIVATE_RISK',
  ARCHIVE_GROUP = 'ARCHIVE_GROUP',
  REACTIVATE_GROUP = 'REACTIVATE_GROUP',
  STATUS_CHANGED_RISK = 'STATUS_CHANGED_RISK',
  DESCRIPTION_CHANGED_RISK = 'DESCRIPTION_CHANGED_RISK',
  DELETE_RISK = 'DELETE_RISK',
  UPDATE_RISK = 'UPDATE_RISK',
  DEADLINE_DATE_SET = 'DEADLINE_DATE_SET',
  TAGS_ADDED_RISK = 'TAGS_ADDED_RISK',
  ASSETS_ADDED_RISK = 'ASSETS_ADDED_RISK',
  OWNER_ASSIGN_RISK = 'OWNER_ASSIGN_RISK',
  OWNER_UN_ASSIGN_RISK = 'OWNER_UN_ASSIGN_RISK',
  IGNORE_TASK = 'IGNORE_TASK',
  ACCEPT_TASK = 'ACCEPT_TASK',
  REOPEN_TASK = 'REOPEN_TASK',
  UPDATE_QUESTION_SEVERITY = 'UPDATE_QUESTION_SEVERITY',
  UPDATE_QUESTION_DESCRIPTION = 'UPDATE_QUESTION_DESCRIPTION',
  UPDATE_PARTIAL_REPRESENTATION = 'UPDATE_PARTIAL_REPRESENTATION',
  UPDATE_POSITIVE_ANSWER = 'UPDATE_POSITIVE_ANSWER',
  AI_ASSESSMENT_STARTED = 'AI_ASSESSMENT_STARTED',
  AI_ASSESSMENT_RESTARTED = 'AI_ASSESSMENT_RESTARTED',
  AI_ASSESSMENT_FINALIZED = 'AI_ASSESSMENT_FINALIZED',
  AI_ASSESSMENT_DELETED = 'AI_ASSESSMENT_DELETED',
  FRAMEWORK_QUESTION_TYPE_UPDATED = 'FRAMEWORK_QUESTION_TYPE_UPDATED',
  FRAMEWORK_PARTIAL_REPRESENTATION_UPDATED = 'FRAMEWORK_PARTIAL_REPRESENTATION_UPDATED',
  FRAMEWORK_INITIAL_COLLECTION_METHOD_UPDATED = 'FRAMEWORK_INITIAL_COLLECTION_METHOD_UPDATED',
  FRAMEWORK_ARTIFACT_SETTING_UPDATED = 'FRAMEWORK_ARTIFACT_SETTING_UPDATED',
  FRAMEWORK_COMMENT_SETTING_UPDATED = 'FRAMEWORK_COMMENT_SETTING_UPDATED',
  FRAMEWORK_REVIEWER_SETTING_UPDATED = 'FRAMEWORK_REVIEWER_SETTING_UPDATED',
  FRAMEWORK_GLOBAL_CONTROL_UPDATED = 'FRAMEWORK_GLOBAL_CONTROL_UPDATED',
  FRAMEWORK_INTEGRATION_SETTING_UPDATED = 'FRAMEWORK_INTEGRATION_SETTING_UPDATED',
  FRAMEWORK_SMART_MAPPING_SETTING_UPDATED = 'FRAMEWORK_SMART_MAPPING_SETTING_UPDATED',
  FRAMEWORK_DURATION_UPDATED = 'FRAMEWORK_DURATION_UPDATED',
  FRAMEWORK_REVIEWER_ASSIGNED = 'FRAMEWORK_REVIEWER_ASSIGNED',
  FRAMEWORK_REVIEWER_REMOVED = 'FRAMEWORK_REVIEWER_REMOVED',
  FRAMEWORK_START_FRESH_IMMEDIATE = 'FRAMEWORK_START_FRESH_IMMEDIATE',
  FRAMEWORK_START_FRESH_SCHEDULED = 'FRAMEWORK_START_FRESH_SCHEDULED',
  FRAMEWORK_REASSESSMENT_STARTED_IMMEDIATE = 'FRAMEWORK_REASSESSMENT_STARTED_IMMEDIATE',
  FRAMEWORK_REASSESSMENT_SCHEDULED = 'FRAMEWORK_REASSESSMENT_SCHEDULED',
  FRAMEWORK_REASSESSMENT_COMPLETED = 'FRAMEWORK_REASSESSMENT_COMPLETED',
  FRAMEWORK_REASSESSMENT_CANCELLED = 'FRAMEWORK_REASSESSMENT_CANCELLED',
  FRAMEWORK_IMPORTED = 'FRAMEWORK_IMPORTED',
  FRAMEWORK_ARCHIVED = 'FRAMEWORK_ARCHIVED',
  FRAMEWORK_DELETED = 'FRAMEWORK_DELETED',
}

export enum LogsTypeEnum {
  QUESTION = 'QUESTION',
  RISK = 'RISK',
  RISK_GROUP = 'RISK_GROUP',
  SIGNATURE = 'SIGNATURE',
  ASSESSMENT_LOCKED = 'ASSESSMENT_LOCKED',
  ASSESSMENT_UNLOCK = 'ASSESSMENT_UNLOCK',
  GLOBAL_CONTROL_CREATE = 'GLOBAL_CONTROL_CREATE',
  GLOBAL_CONTROL_DELETE = 'GLOBAL_CONTROL_DELETE',
  INSURANCE_COVERAGE_GRANTED = 'INSURANCE_COVERAGE_GRANTED',
  AI_ASSESSMENT = 'AI_ASSESSMENT',
  AI_ASSESSMENT_THIRD_PARTY = 'AI_ASSESSMENT_THIRD_PARTY',
  FRAMEWORK = 'FRAMEWORK',
}
